
















import { Component, Vue } from 'vue-property-decorator';
import { ToastApi } from '@/services/api/api.toasts';

import CreateToast from '@/components/dashboard/toast/CreateToast.vue';
import EditToast from '@/components/dashboard/toast/EditToast.vue';
import DeleteToast from '@/components/dashboard/toast/DeleteToast.vue';
import { Toast } from '@/types/apiServerContract';

@Component({
    components: { CreateToast, EditToast, DeleteToast }
})
export default class Toasts extends Vue {
	toasts: Toast[] = [];

	addToast(toast: Toast) {
	    this.toasts.push(toast);
	}

	updateToast(toast: Toast) {
	    const oldToast = this.toasts.find(x => x.id === toast.id);
	    if (oldToast) {
	        Object.assign(oldToast, toast);
	    } else {
	        this.addToast(toast);
	    }
	}

	deleteToast(id: string) {
	    this.toasts.splice(
	        this.toasts.findIndex(x => x.id === id),
	        1
	    );
	}

	async getToasts() {
	    const result = await ToastApi.GetToasts();
	    this.toasts = result.toasts;
	}

	created() {
	    this.getToasts();
	}
}
